import bannerImage from '../../assets/images/artist_application_banner.png';

export default function Banner({ children }) {
    return (
        <div className="relative">
            <img
                src={bannerImage}
                alt="440 Artist"
                width="1728"
                height="948"
                fetchPriority="high"
                className="block aspect-[1729/948] w-full object-cover max-[767px]:aspect-square"
            />
            <div className="absolute inset-x-0 bottom-[97px] z-[1] max-[767px]:relative max-[767px]:inset-auto max-[767px]:-mt-[110px] max-[767px]:mb-[30px]">
                <div className="mx-auto flex max-w-[99.4375rem] flex-col gap-[9px] px-[15px] text-center text-white max-[767px]:gap-5 min-[1025px]:px-10">
                    {children}
                </div>
            </div>
        </div>
    );
}
